import React from "react";
import { Phone, Mail, Link, MapPin } from "lucide-react";

// Image
import logoLight from "assets/images/logo/logo2.png";
import logoDark from "assets/images/logo/logo2.png";

const Footer = () => {
  return (
    <React.Fragment>
      <footer
        className="relative pt-20 pb-12 border-t border-slate-200  text-white dark:border-zinc-800"
        style={{ direction: "rtl" }}
      >
        <div className="absolute left-0 size-64 -top-16 opacity-10 blur-3xl"></div>
        <div className="container bg-gradient-to-t from-[#274294] via-[#102b75] to-[#2e3d68]  py-10 rounded-lg 2xl:max-w-[87.5rem] px-4 mx-auto">
          <div className="relative z-10 grid grid-cols-12 gap-5 xl:grid-cols-12">
            <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-4">
              <h5 className="mb-4 font-medium tracking-wider dark:text-zink-50">
                <a href="#!">
                  <img
                    src={logoDark}
                    alt="لوگو"
                    className="block h-10 dark:hidden"
                  />
                </a>
              </h5>
              <ul className="flex flex-col gap-3 mt-8 text-15">
                <p className="leading-8">
                  هاویر کشت یک سامانه مدیریت محصول چغندر قند برای پیمانکاران و
                  کشاورزان است که توسط شرکت هوشمند پرداز هاویر (Havir.ir) طراحی
                  و توسعه داده شده است
                </p>
              </ul>
            </div>
            <div className="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
              <h5 className="mb-4 font-medium tracking-wider text-white dark:text-zink-50">
                آدرس
              </h5>
              <ul className="flex flex-col gap-3 text-15 text-right">
                <li className="flex items-center space-x-4">
                  <p className="transition-all  w-full  duration-200 ease-linear text-white dark:text-zinc-400 hover:text-slate-800 dark:hover:text-zinc-50">
                    خرم آباد، کیلومتر ۵ جاده تهران، پردیس دانشگاهی کمالوند، پارک
                    علم و فناوري لرستان، طبقه هم کف، شركت هاویر
                  </p>
                </li>
                <li className="flex items-center space-x-2">
                  <Phone className="text-white" />
                  <a
                    href="tel:09374683780"
                    className="transition-all duration-200 ease-linear text-white dark:text-zinc-400 hover:text-slate-800 dark:hover:text-zinc-50"
                  >
                    09374683780
                  </a>
                </li>
                <li className="flex items-center space-x-2">
                  <Mail className="text-white" />
                  <a
                    href="mailto:info@havirkesht.ir"
                    className="transition-all duration-200 ease-linear text-white dark:text-zinc-400 hover:text-slate-800 dark:hover:text-zinc-50"
                  >
                    info@havirkesht.ir
                  </a>
                </li>
                <li className="flex items-center space-x-2">
                  <Link className="text-white" />
                  <a
                    href="https://www.havirkesht.ir"
                    className="transition-all duration-200 ease-linear text-white dark:text-zinc-400 hover:text-slate-800 dark:hover:text-zinc-50"
                  >
                    www.havirkesht.ir
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-10 mt-10 bg-white text-center border-t text-black dark:text-zinc-400 dark:border-zinc-800 text-16">
          <p>
            تمامی حقوق مادی و معنوی این سامانه متعلق به{" "}
            <span className="text-blue-700">(www.Havir.ir)</span> شرکت هاویر می
            باشد
          </p>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
